import axios from "axios";
import moment from "moment";
import { BASE_URL, SR_SEARCH } from "./../api/api";

// day of week starts at 0 with Sunday based on Date() module
const dayOfWeekMapping = {
  0: "Sun",
  6: "Sat",
  5: "Fri",
  4: "Thu",
  3: "Wed",
  2: "Tue",
  1: "Mon",
};

const defaultImg =
  "https://www.redditstatic.com/avatars/avatar_default_01_A5A4A4.png";

const defaultSrImg =
  "https://www.redditstatic.com/avatars/avatar_default_02_7E53C1.png";

const convertDate = (date) => {
  const selectedDate = new Date(date);
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return selectedDate.toLocaleDateString("en-GB", options);
};

const generateTimeLabels = (gap = "", morning = "am", afternoon = "pm") => {
  let timeOfDay = [`12${gap}${morning}`];
  for (let i = 1; i < 12; i++) {
    timeOfDay.push(`${i}${gap}${morning}`);
  }
  timeOfDay.push(`12${gap}${afternoon}`);
  for (let i = 1; i < 12; i++) {
    timeOfDay.push(`${i}${gap}${afternoon}`);
  }
  return timeOfDay;
};

const displayCurrentHour = (current = true, displayHour) => {
  if (current) {
    let d = new Date();
    let currentHour = d.getHours();

    if (currentHour === 0) {
      return `12 am`;
    } else if (currentHour === 12) {
      return `12 pm`;
    } else if (currentHour < 12) {
      return `${currentHour} am`;
    } else {
      return `${currentHour - 12} pm`;
    }
  } else {
    if (displayHour === 0) {
      return `12 am`;
    } else if (displayHour === 12) {
      return `12 pm`;
    } else if (displayHour < 12) {
      return `${displayHour} am`;
    } else {
      return `${displayHour - 12} pm`;
    }
  }
};

const convertToMilitaryTime = (hour) => {
  hour = hour.replace(" ", "");
  if (hour.includes("am")) {
    // edge case 12am
    if (Number(hour.replace("am", "")) === 12) {
      return 0;
    }
    return hour.replace("am", "");
  } else {
    return Number(hour.replace("pm", "")) + 12;
  }
};

const formatDateTimeToUnix = (date, selectedHour) => {
  const hour = convertToMilitaryTime(selectedHour);
  const [year, month, day] = date.split("-");

  const formattedDate = new Date(
    +year,
    month - 1, // Jan === 0
    +day,
    +hour,
    +"00",
    +"00"
  );

  return formattedDate.getTime();
};

const formatUnixToDatetime = (timestamp) => {
  const d = new Date(timestamp);

  const date = `${d.getFullYear()}-${d.getMonth() + 1 < 10 ? "0" : ""}${
    d.getMonth() + 1
  }-${d.getDate() < 10 ? "0" + d.getDate() : d.getDate()}`;

  const hour = `${displayCurrentHour(false, d.getHours())}`;

  return [date, hour];
};

const subredditFound = async (url) => {
  try {
    const response = await axios.get(url);
    return response.data.data.children.length > 0;
  } catch (error) {
    console.log("Axios GET subreddit error", error);
    return false;
  }
};

const convertRecommendationDate = (dayOfWeek) => {
  let recommendedDayIdx;

  for (let i = 0; i < Object.values(dayOfWeekMapping).length; i++) {
    if (Object.values(dayOfWeekMapping)[i] === dayOfWeek.slice(0, 3)) {
      recommendedDayIdx = i === 0 ? 7 : i;
      break;
    }
  }

  // find the next possible day of week
  let today = moment();
  for (let i = 0; i < 8; i++) {
    if (recommendedDayIdx === today.isoWeekday()) {
      break;
    }
    today = today.add(1, "days");
  }
  // console.log(
  //   "formatUnixToDatetime(today._d)[0]",
  //   formatUnixToDatetime(today._d)[0]
  // );
  return formatUnixToDatetime(today._d)[0];
};

const getURLParams = (url) => {
  let params = {};
  const keyValueArray = url.slice(1).split("&");
  for (let i = 0; i < keyValueArray.length; i++) {
    params[keyValueArray[i].split("=")[0]] = keyValueArray[i].split("=")[1];
  }
  return params;
};

const loginCheck = (params, userData, history) => {
  if (userData.username !== null) {
    // Logged in
    history.push(
      `/schedule${
        params
          ? `?sr=${params.searchTerm}&day=${params.dayOfWeek}&time=${params.time}`
          : ""
      }`
    );
  } else {
    // Not loggined in
    params && sessionStorage.setItem("rec", JSON.stringify(params));
    window.location.assign(`${BASE_URL}/reddit/login`);
  }
};

const sortAlphabetically = (array) => {
  array.sort(function (a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
  return array;
};

const validateSubreddit = async (subreddit) => {
  const search = subreddit.toLowerCase().replace(/\s/g, "");
  const url = `${SR_SEARCH}${search}`;

  return subredditFound(url);
};

/**
 * Function to compute the difference in days from today's date
 *
 * @param {number} date as unix timestamp
 * @returns {array}
 * 1 for number of days
 * 2 for number of hours
 * 3 for number of minutes
 */
const computeTimeDifference = (date) => {
  let todaysDate = new Date();
  let differenceInMiliseconds = todaysDate.getTime() - date;
  let differenceInDays = Math.floor(
    differenceInMiliseconds / (1000 * 3600 * 24)
  );
  let differenceInHours = Math.floor(differenceInMiliseconds / (1000 * 3600));

  if (differenceInDays > 0) {
    return [3, differenceInDays];
  } else if (differenceInHours > 0) {
    return [2, differenceInHours];
  } else {
    // minutes
    return [1, Math.ceil(differenceInMiliseconds / (1000 * 60))];
  }
};

const displayTime = (timeDifference) => {
  let outputTime = String(timeDifference[1]);
  let years = Math.floor(timeDifference[1] / 365);

  if (timeDifference[0] === 3 && years >= 1) {
    years > 1
      ? (outputTime = `${years} years`)
      : (outputTime = `${years} year`);
  } else if (timeDifference[0] === 3) {
    timeDifference[1] > 1 ? (outputTime += " days") : (outputTime += " day");
  } else if (timeDifference[0] === 2) {
    timeDifference[1] > 1 ? (outputTime += " hours") : (outputTime += " hour");
  } else {
    timeDifference[1] > 1
      ? (outputTime += " minutes")
      : (outputTime += " minute");
  }
  return (outputTime += " ago");
};

const kFormatter = (num) => {
  return Math.abs(num) > 999
    ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
    : Math.sign(num) * Math.abs(num);
};

const isSubredditSearch = (subredditSearch) => {
  // subredditSearch state passed down as prop
  if (
    subredditSearch ||
    window.location.href.includes("subreddit") ||
    window.location.href.includes("schedule")
  ) {
    return true;
  }
  return false;
};

const prepareTimeInterval = (timeInterval) => {
  return timeInterval.split(" ")[1].toLowerCase() === "time"
    ? "all"
    : timeInterval.split(" ")[1].toLowerCase();
};

export {
  dayOfWeekMapping,
  defaultImg,
  convertDate,
  generateTimeLabels,
  displayCurrentHour,
  convertToMilitaryTime,
  formatDateTimeToUnix,
  formatUnixToDatetime,
  subredditFound,
  convertRecommendationDate,
  getURLParams,
  loginCheck,
  sortAlphabetically,
  validateSubreddit,
  displayTime,
  computeTimeDifference,
  kFormatter,
  defaultSrImg,
  isSubredditSearch,
  prepareTimeInterval,
};
